import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { UiLoaderModule } from '@netfoundry-ui/ui/loader';
import { FormsModule } from '@angular/forms';
import { TicketFormComponent } from './ticket-form.component';

@NgModule({
    imports: [CommonModule, FormsModule, MatDialogModule, UiLoaderModule],
    declarations: [TicketFormComponent],
    exports: [TicketFormComponent],
})
export class FeatureFormTicketFormModule {}
